import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { EditContactEvent, } from '../../../../../constants/events';
import { Layout, Cell } from 'wix-style-react';
var AssigneeInput = /** @class */ (function (_super) {
    __extends(AssigneeInput, _super);
    function AssigneeInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssigneeInput.prototype.onAssigneeChanged = function (assigneeId) {
        this.props.log(EditContactEvent.SELECT_ASSIGNEE, { assignee: assigneeId });
        this.props.onValueChange(assigneeId || '');
    };
    AssigneeInput.prototype.render = function () {
        var _this = this;
        return (React.createElement(Layout, { gap: 0 },
            React.createElement(Cell, { span: 12 }, this.props.component && (React.createElement(this.props.component, { entityId: this.props.contactId, entityType: "Contact", toggleType: "basic", assignedContributorId: this.props.assigneeId, onChange: function (assigneId) { return _this.onAssigneeChanged(assigneId); }, originAppSlug: "edit-contact", zIndex: 5001, fullWidth: true, appendTo: "parent" })))));
    };
    return AssigneeInput;
}(React.PureComponent));
export default translate()(AssigneeInput);
//# sourceMappingURL=AssigneeInput.js.map